import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { getMethod2 } from "../../functions/httpMethods";
import InputContainer from "../general/InputContainer";
import NunitoText from "../general/NunitoText";
import ReusableButton from "../general/ReusableButton";
import ReusableSelect from "../general/ReusableSelect";
import ReusableTextField from "../general/ReusableTextField";
const radioStyle = { color: "#000" };

export default function EditParticipantRankingModal({
  confirmFunction,
  // availableAwards,
  cancelConfirm,
  participant,
  awardsEndpoint,
}) {
  // console.log("aaaafff");
  // console.log(availableAwards);
  // console.log(participant);
  // participant.award = null;
  const [award, setAward] = useState(
    participant.award ? participant.award : null
  );
  const [availableAwards, setAvailableAwards] = useState([]);
  useEffect(() => {
    if (awardsEndpoint) {
      getMethod2(awardsEndpoint, "").then((res) => {
        setAvailableAwards(
          res?.map((award) => {
            return { value: award?.filter_id, option: award?.filter_name };
          })
        );
      });
    }
  }, [awardsEndpoint]);
  console.log("hereee");
  console.log(availableAwards);
  // const [award, setAward] = useState(null);
  // console.log(
  //   participant?.school_rank?.substring(
  //     participant.school_rank.lastIndexOf(" ") + 1
  //   )
  // );
  const [schoolRankNumber, setSchoolRankNumber] = useState(
    participant.school_rank
      ? participant?.school_rank?.substring(
          participant.school_rank.lastIndexOf(" ") + 1
        )
      : null
  );
  const [countryRankNumber, setCountryRankNumber] = useState(
    participant.country_rank
      ? participant?.country_rank?.substring(
          participant.country_rank.lastIndexOf(" ") + 1
        )
      : null
  );
  // const [globalRankString, setGlobalRankString] = useState(
  //   participant.global_rank
  //     ? participant?.global_rank?.substring(
  //         0,
  //         participant.global_rank.lastIndexOf(" ")
  //       )
  //     : null
  // );
  const [globalRankNumber, setGlobalRankNumber] = useState(
    participant.global_rank
      ? participant?.global_rank?.substring(
          participant.global_rank.lastIndexOf(" ") + 1
        )
      : null
  );
  const [points, setPoints] = useState(
    participant?.points ? parseFloat(participant?.points) : null
  );

  const handleConfirm = () => {
    let changedValues = {};
    if (participant?.award !== award) {
      changedValues["award"] = award;
    }
    if (participant?.school_rank !== award + " " + schoolRankNumber) {
      changedValues["school_rank"] = schoolRankNumber;
    }
    if (participant?.country_rank !== award + " " + countryRankNumber) {
      changedValues["country_rank"] = countryRankNumber;
    }
    if (
      participant?.global_rank !== award + " " + globalRankNumber &&
      globalRankNumber !== null
    ) {
      changedValues["global_rank"] = globalRankNumber;
    }
    if (participant?.points !== points) {
      changedValues["points"] = points;
    }
    // console.log(changedValues);
    if (Object.keys(changedValues).length === 0) {
      cancelConfirm();
    } else {
      confirmFunction(participant.index_no, changedValues);
    }
  };

  return (
    <Box
      className="popUpModal"
      style={{
        width: 705,
        minHeight: 310,
        position: "fixed",
        top: "50%",
        right: "50%",
        zIndex: 15,
      }}
    >
      <NunitoText
        value="Edit Participant Ranking"
        fontSize={30}
        fontWeight={600}
        color="#5E75C3"
        marginTop={30}
      />
      <NunitoText
        value={`Update ranking of ${participant.name}`}
        fontSize={20}
        fontWeight={600}
      />
      <NunitoText
        value={`All field are optional`}
        fontSize={20}
        fontWeight={600}
      />

      {/* CONTENT */}
      <Box
        style={{
          margin: "30px 50px 20px",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          marginLeft="35px"
          gap={20.5}
        >
          <NunitoText
            value={`Award:`}
            fontSize={20}
            fontWeight={600}
            marginTop={2}
            color={participant?.award === award ? "gray" : "black"}
          />
          <ReusableSelect
            type="type2"
            state={award ? award : "null"}
            setState={setAward}
            btnBgColor="#144A94"
            height={45}
            width={300}
            options={[
              participant.award === null && {
                value: null,
                option: "_Not_Calculated",
              },
              ...availableAwards.map((award) => {
                return {
                  value: award.value,
                  option: award.option,
                };
              }),
              // { value: "PERFECT SCORE", option: "PERFECT SCORE" },
              // { value: "GOLD", option: "GOLD" },
              // { value: "SILVER", option: "SILVER" },
              // { value: "BRONZE", option: "BRONZE" },
              // { value: "HONORABLE MENTION", option: "HONORABLE MENTION" },
              // {
              //   value: "CERTIFICATE OF PARTICIPATION",
              //   option: "CERTIFICATE OF PARTICIPATION",
              // },
            ]}
          />
        </Box>
        <InputContainer
          label="School_Rank:"
          labelColor={
            (participant?.school_rank === null && award === null) ||
            participant?.school_rank === award + " " + schoolRankNumber
              ? "gray"
              : "black"
          }
          field={
            <ReusableTextField
              type="default"
              number
              width={300}
              placeholder="Enter school rank here"
              state={schoolRankNumber}
              setState={(value) => {
                value >= 1
                  ? setSchoolRankNumber(value)
                  : setSchoolRankNumber(null);
              }}
            />
          }
        />
        <InputContainer
          label="Country_Rank:"
          labelColor={
            (participant?.country_rank === null && award === null) ||
            participant?.country_rank === award + " " + countryRankNumber
              ? "gray"
              : "black"
          }
          field={
            <ReusableTextField
              type="default"
              number
              width={300}
              placeholder="Enter country rank here"
              state={countryRankNumber}
              setState={(value) => {
                value >= 1
                  ? setCountryRankNumber(value)
                  : setCountryRankNumber(null);
              }}
            />
          }
        />
        <InputContainer
          label="Global_Rank:"
          labelColor={
            (participant?.global_rank === null && award == null) ||
            participant?.global_rank === award + " " + globalRankNumber
              ? "gray"
              : "black"
          }
          field={
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap={1}
              marginLeft={9.5}
            >
              <ReusableTextField
                type="default"
                number
                width={300}
                placeholder="global rank NO"
                // required
                state={globalRankNumber}
                setState={(value) => {
                  value >= 1
                    ? setGlobalRankNumber(Number(value))
                    : setGlobalRankNumber(null);
                }}
              />
            </Box>
          }
        />
        {/* SCORE */}
        <InputContainer
          label="Score"
          labelColor={
            (participant?.points === null && award == null) ||
            parseFloat(participant?.points) === points
              ? "gray"
              : "black"
          }
          field={
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap={1}
              marginLeft={9.5}
            >
              <ReusableTextField
                type="default"
                number
                width={300}
                placeholder="Enter Score here"
                state={points}
                setState={(value) => {
                  value >= 1 ? setPoints(Number(value)) : setPoints(null);
                }}
              />
            </Box>
          }
        />
      </Box>

      <Grid
        container
        justifyContent="space-evenly"
        style={{ marginBlock: "30px 20px" }}
      >
        <ReusableButton
          text="Cancel"
          bgColor="#8D8D8D"
          fontSize={25}
          height={63}
          width={280}
          onClick={() => cancelConfirm()}
        />
        <ReusableButton
          text="Confirm"
          bgColor="#5E75C3"
          fontSize={25}
          height={63}
          width={280}
          onClick={handleConfirm}
        />
      </Grid>
    </Box>
  );
}
